import React from "react";
import AppLayout from "../components/AppLayout";
import About from "../components/About";
import ChatCTA from "../components/ChatCTA";

const ContactPage = () => (
    <AppLayout pageTitle="Chi Siamo & Contatti" showBack backTo="/">
        <About />
        <ChatCTA />
    </AppLayout>
);

export default ContactPage;
